function toggleSidebar(isOpen) {
    console.log('clicked');
    const sidebar = document.querySelector('.category-sidebar');
    if (isOpen) {
        sidebar.style.left = '0%';
    } else {
        sidebar.style.left = '-100%';
    }
}